import { Dictionary } from "@/utils/Dictionary";

export interface IFilterEval {
  "@type": string;
  pass: boolean;
  potentialMatch: boolean;
  uncertainMatch: boolean;
}

export interface IOpportunitiesFilterEval extends IFilterEval {
  input: {
    criteria?: Dictionary<any>;
    opportunity: Dictionary<any>;
  };
}

export interface IPeopleFilterEval extends IFilterEval {
  input: {
    criteria?: Dictionary<any>;
    person: Dictionary<any>;
  };
}

export interface IAndFilterEval extends IFilterEval {
  and: IFilterEval[];
}

export interface IInverseFilterEval extends IFilterEval {
  not: IFilterEval;
}

export interface IOrFilterEval extends IFilterEval {
  or: IFilterEval[];
}

export interface IConcreteFilterEval extends IFilterEval {
  id: string;
}

export function isAndFilterEval(filter: IFilterEval): filter is IAndFilterEval {
  return filter["@type"] === "and";
}

export function isConcreteFilterEval(filter: IFilterEval): filter is IConcreteFilterEval {
  return filter["@type"] === "concrete";
}

export function isInverseFilterEval(filter: IFilterEval): filter is IInverseFilterEval {
  return filter["@type"] === "not";
}

export function isOrFilterEval(filter: IFilterEval): filter is IOrFilterEval {
  return filter["@type"] === "or";
}
